import { ReduxPageType } from '@common-types/ReduxPage';
import { Routes } from '@common/constants';
import { TranslationsFunc } from '@lang';
import { BasketDetails } from 'shared-types/Basket';
import { separateAndGroupPackageAndNonPackageItems } from '../ItemListingRows/helpers/separateAndGroupPackageAndNonPackageItems';

type ReduxProps = {
  spaPage: ReduxPageType;
  tablesPage: ReduxPageType;
  roomsPage: ReduxPageType;
  golfPage?: ReduxPageType;
};

export const groupByType = (basketItems: NonNullable<BasketDetails['items']>) =>
  basketItems.reduce((itemsMap, item) => {
    const type = item?.type?.startsWith('spa') ? 'spa' : item.type;
    return {
      ...itemsMap,
      [String(type)]: [...(itemsMap[String(type)] || []), item],
    };
  }, {});

export const pluralizeAdults = (adults: number, t: TranslationsFunc) => {
  return adults === 1
    ? t('basketDrawer.helpers.pluraliseAdults.singular')
    : t('basketDrawer.helpers.pluraliseAdults.plural');
};

export const pluralizeGuests = (guests: number, t: TranslationsFunc) => {
  return guests === 1
    ? t('basketDrawer.numberOfGuests.singular')
    : t('basketDrawer.numberOfGuests.plural');
};

export const pluralizeChildren = (children: number, t: TranslationsFunc) => {
  return children === 1
    ? t('basketDrawer.helpers.pluraliseChildren.singular')
    : t('basketDrawer.helpers.pluraliseChildren.plural');
};

export const calculateTotalNumberOfItemsInBasket = (items: NonNullable<BasketDetails['items']>) => {
  const groupedItemsByType = separateAndGroupPackageAndNonPackageItems(items, groupByType);
  return Object.values(groupedItemsByType).reduce((acc, items) => acc + items.length, 0);
};

export const mapModules = (
  modules: string[],
  { spaPage, tablesPage, roomsPage, golfPage }: ReduxProps
) => {
  return modules
    .map((m) => {
      if (m === 'spa' && spaPage) {
        return {
          ...spaPage,
          route: Routes.SPA_HOME,
        };
      }
      if (m === 'golf' && golfPage) {
        return {
          ...golfPage,
          route: Routes.GOLF_HOME,
        };
      }
      if (m === 'tables' && tablesPage) {
        return { ...tablesPage, route: Routes.TABLES_HOME, slug: 'dining' };
      }
      if (m === 'rooms' && roomsPage) {
        return {
          ...roomsPage,
          route: Routes.ROOM_LIST,
        };
      }
      return null;
    })
    .filter(Boolean);
};
